import { Component, Input, OnInit } from '@angular/core';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import * as actions from '../course-player.actions';
import * as fromCoursePlayer from '../course-player.reducer';

@Component({
  selector: 'app-audio-play-pause-button',
  templateUrl: './audio-play-pause-button.component.html'
})
export class AudioPlayPauseButtonComponent implements OnInit {
  faPlay = faPlay;
  faPause = faPause;  

  @Input()
  showPlayButton!: boolean

  @Input()
  disabled!: boolean

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>) { }

  ngOnInit(): void {
  }

  play() {
    this.store.dispatch(new actions.Play());
  }

  pause() {
    this.store.dispatch(new actions.Pause());
  }
}
